import axios from 'axios';

const getPrompts = () => {
  return axios.get(`${process.env.NEXT_PUBLIC_GRAPPLE_BACKEND_URL}prompt`, {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
  });
};

export default getPrompts;
